// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__JN_N2","name":"style_name__xcRJU","social":"style_social__ZC6zS","link":"style_link__HaNAv"};